import $ from "jquery";
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import UTable from './user_table.react.js';
import CSSModules from 'react-css-modules';
import styles from './all.css';
import ConfirmDialog from '../../widgets/confirm_dialog.react.js';
import EmployeeEditDialog from './employee_edit.react.js';

const list_url = config.server + config.api_path + '/admin/user/all'
const edit_url = config.server + config.api_path + '/admin/user/edit/'
const resend_url = (
  config.server + config.api_path + '/admin/user/resend_activate_email'
)
const delete_url = (
  config.server + config.api_path + '/admin/user/destroy/'
)

class AdminUserAllView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect_mode: false
    }

    if (props.match && props.match.path.startsWith('/admin/user/edit/') &&
      Object.keys(props.match.params)
      .length > 0) {
      this.state['redirect_mode'] = true
    }

    this.load_data = this.load_data.bind(this)
    this.delete_item = this.delete_item.bind(this)
    this.edit_data = this.edit_data.bind(this)
    this.open_edit = this.open_edit.bind(this)
    this.open_resend = this.open_resend.bind(this)
    this.open_delete = this.open_delete.bind(this)
    this.handle_resend = this.handle_resend.bind(this)
    this.handle_delete = this.handle_delete.bind(this)
  }

  componentDidMount() {
    if (!this.state.redirect_mode) return

    var self = this;
    const emp_id = this.props.match.params.emp_id
    $.get({
        dataType: 'json',
        url: list_url + '/' + emp_id,
        data: auth.with_session({}),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec === 0) {
          self.edit_dialog.refs.component.open_edit(data.ret)
        } else if (_err && _err.ec === 403) {
          self.props.unauthorized()
        }
      })
  }

  load_data(rowsPerPage, offset, cb) {
    $.get({
        dataType: 'json',
        url: list_url,
        data: auth.with_session({}, true),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec === 0) {
          cb(data.ret)
        } else if (_err && _err.ec === 403) {
          this.props.unauthorized()
        }
      })
  }

  delete_item(data, cb) {
    console.log('deleting data', data)
    cb()
  }

  edit_data(data, cb) {
    const user_id = data.id
    var self = this;
    $.ajax({
        type: 'PUT',
        dataType: 'json',
        url: edit_url + user_id,
        contentType: 'application/json',
        data: auth.with_session({
          user: {
            first_name: data.user.first_name,
            last_name: data.user.last_name
          }
        }),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        } else if (_err) {
          cb(new Error(_err.em))
        }
      })
  }

  open_edit(data) {
    this.edit_dialog.refs.component.open_edit(data)
  }

  refresh_table() {
    this.table.refresh()
  }

  open_resend(data) {
    this.resend_dialog.open_confirm(data, data.username,
      '/admin/user/all')
  }

  open_delete(data) {
    this.delete_dialog.open_confirm(data, data.username,
      '/admin/user/all')
  }

  handle_resend(data, cb) {
    var self = this;
    $.post({
        dataType: 'json',
        url: resend_url,
        data: auth.with_session({
          email: data.user.username,
        }),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          cb(null)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        } else if (_err) {
          cb(new Error(_err.em))
        }
      })
  }

  handle_delete(data, cb) {
    var self = this;
    $.ajax({
        method: 'DELETE',
        dataType: 'json',
        url: delete_url + data.id,
        data: auth.with_session({}),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        } else if (_err) {
          cb(new Error(_err.em))
        }
      })
  }

  render() {
    return (
      <Card styleName="admin-card">
        <CardHeader
          title="User Management"
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText>
          <EmployeeEditDialog
            ref={(dialog) => {this.edit_dialog = dialog}}
            submit_edit={this.edit_data}
            history={this.props.history}
          >
          </EmployeeEditDialog>
          <ConfirmDialog
            prefix="Resend Invite Link to"
            confirm_text="Resend"
            handle_confirm={this.handle_resend}
            history={this.props.history}
            ref={(dialog) => {this.resend_dialog = dialog}}
          >
          </ConfirmDialog>
          <ConfirmDialog
            prefix="Delete Employee on"
            confirm_text="Delete"
            handle_confirm={this.handle_delete}
            history={this.props.history}
            ref={(dialog) => {this.delete_dialog = dialog}}
          >
          </ConfirmDialog>
          <UTable
            ref={(table) => {this.table = table}}
            open_edit={this.open_edit}
            open_resend={this.open_resend}
            open_delete={this.open_delete}
            load_data={this.load_data}
            delete_employee={this.delete_item}>
          </UTable>
        </CardText>
      </Card>
    )
  }
}

AdminUserAllView.defaultProps = {
  data: [],
  deleted: false
}

export default CSSModules(AdminUserAllView, styles)



// WEBPACK FOOTER //
// ./src/views/admin/users.react.js